import { initialState, ChangeLogState } from "./state";
import { Actions } from './actions';
import { SET_CHANGE_LOG, DOWNLOAD_CHANGE_LOG_CSV_RESPONSE } from "./actionTypes";
import { sortListDescending } from "app/utils/sort.util";

export function ChangeLogReducer(state = initialState, action: Actions): ChangeLogState {
    switch (action.type) {
        case SET_CHANGE_LOG:
            return Object.assign({}, state, {
                changeLog: sortListDescending(action.payload, "eventTime", "number")
            });
        case DOWNLOAD_CHANGE_LOG_CSV_RESPONSE:
            return Object.assign({}, state, {
                downloadChangeLogCsvResponse: action.payload
            });
        default:
            return state;
    }
}
